/**
 * BMO Reducer

 */

// Set initial state

export const initialState = {
    isLoading_bmos: false,
    error: "",
    data:[]
};

export default function bmosReducer(state = initialState, action) {
    switch (action.type) {
        case "RESET_BMOS":
            return {
                ...state,
                data:[]
            };
        case "SET_BMOS":
            return {
                ...state,
                data: action.data
            };
        case "LOADING_BMOS":
            return {
                ...state,
                isLoading_bmos: action.loading,
                error: action.error
            };

        default:
            return state;
    }
}
